<script>
import MenuItem from '../components/menu/MenuItem';
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'WithTheMenu',
  components: {
    MenuItem
  },
  computed: {
    ...mapState({
      // username: state => state.auth.currentUser.name + " " + state.auth.currentUser.surname,
    }),
    ...mapGetters({
      username: 'auth/username',
      agence: 'auth/agence',
      modeSaisie: 'auth/modeSaisie',
    }),
  },
  methods:{
    logout(){
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    }
  }
};
</script>


<template>
    <div class="main">
        <nav>
          <img src="../assets/menuBackground.png">
          <div class="header">
              <div class="header__avatar">
                <img src="../assets/userIcon.png">
              </div>
              <div class="header__text">
                <div class="header__text__username"> {{username}}</div>
                <div class="header__text__agencename"> {{agence}}</div>
              </div>
              <i class="header__logIcon material-icons md-18" @click="logout()">power_settings_new</i>
          </div>

          <div class="links">
              <!-- <router-link class="links__routerLink" to="/accueil"><MenuItem text="Accueil" icon="baseline_view_carousel_white_48dp"/></router-link> -->
              <MenuItem text="Tableau de bord"  icon="baseline_view_carousel_white_48dp"  route="/accueil" v-if="this.can('lecture', 'projetAnalyses')"/>
              <MenuItem text="Projets"          icon="baseline_architecture_white_48dp"   route="/projets" v-if="this.can('lecture', 'projetBasic')"/>
              <MenuItem text="Temps passés"     icon="baseline_history_white_48dp"        route="/saisie" v-if="this.can('lecture', 'temps')"/>
              <MenuItem text="Equipe"           icon="baseline_sports_kabaddi_white_48dp" route="/equipe/utilisateurs" v-if="this.can('lecture', 'projetAnalyses')"/>
              <!-- <MenuItem text="Agence"           icon="baseline_bar_chart_white_48dp"      route="/agence" v-if="this.agence == 'Sphem' && this.can('lecture', 'res')" /> -->
              <MenuItem text="Agence"           icon="baseline_bar_chart_white_48dp"      route="/agence" v-if="this.can('lecture', 'projetAnalyses')" beta="true" />
              <MenuItem text="Prospects"        icon="baseline_rowing_white_48dp"         route="/accueil" v-if="this.agence == 'Sphem' && this.can('lecture', 'res')" />
              <MenuItem text="Contacts"         icon="baseline_contact_mail_white_48dp"   route="/contacts" v-if="this.can('lecture', 'contacts')" beta="true"/>

              <div class="links__frontier"></div>
              <MenuItem text="Paramètres"       icon="baseline_settings_white_48dp"       route="/params/" v-if="this.can('lecture', 'params')" />
              <MenuItem text="Tests"            icon="baseline_biotech_white_48dp"        route="/test" v-if="this.agence == 'Sphem' && this.can('lecture', 'res')" />
              <MenuItem text="Backoffice"       icon="iconSet-02"                         route="/backoffice" v-if="this.agence == 'Sphem' && this.can('lecture', 'res')" />
              <!-- <div class="menu-reduction">
                <img class="menu-reduction__icon" src="../assets/icons/baseline_switch_right_white_48dp.png">
                <div class="menu-reduction__text">Réduire le menu</div>
                <div class="menu-reduction__arrow"><img src="../assets/icons/baseline_chevron_left_white_48dp.png"></div>
              </div> -->
          </div>
        </nav>

        <!-- <div v-bind:key='item' v-for="item in info">
        <a v-bind:href="item._id"><h1>{{item.title}}</h1></a>
        <p>{{item.description}}</p>
        </div>
        <input id="textTitle" type="text"><input id="textDescription" type="text">
        <button @click="postIt()">Cliquez ici !</button> -->
    </div>
</template>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/main.scss';

.main{
    // display: flex;
    position: fixed;
    left: 0;
    z-index: 50;
    // position: -webkit-sticky;
}

nav{
  //border-radius: 10px;
  //margin-left: -10px; //pour échapper le border-radius
  //padding-left: 10px; //pour qu'il n'y ai rien dans ces 10px hors fenêtre

  min-height: 100vh;
  width: 330px;
  // overflow: hidden;
  position: relative;
  box-shadow: 1px 1px 5px rgba(0,0,0,0.5);
  display: flex;
  flex-direction: column;

  & img{
    width: 100%; //min-width si je veux garder la proportionalité pour une photo
    height: 100%;
    position: absolute;
    z-index: -1;
  }
}

.header{
  margin: 50px 0 100px 25px;
  display: flex;
  align-items: center;

  &__avatar{
    height: 60px;
    width: 60px;
    border-radius: 50px;
    margin-right: 10px;
    overflow: hidden;
    border: $main solid 3px;

    & img{
      position: static;
      width: 100%;
    }
  }

  &__text{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: $menuTextColor;
    @include myFont();

    &__username{
      font-size: 18px;
      font-weight: 600;
    }

    &__agencename{
      font-size: 15px;
      font-weight: 300;
    }
  }

  &__logIcon{
    cursor: pointer;
    color: white;
    margin-right : 34px;
  }
}

.links{
  margin: 0 0 0 25px; //25px idem header
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px;
  margin-right: 10%;

  &__frontier{
    flex: 1;
    border-bottom: solid 1px #aaaaaa;
  }
}

// .menu-reduction{
//     display: flex;
//     align-items: center;
//     margin-top: 10px;
//     cursor: pointer;
//     border-radius: 5px;
//     padding: 2px 0 2px 5px;
//     text-decoration: none;
//     color: $menuTextColor;

//     &:hover{
//       background-color: rgba(200,200,200,0.2);
//     }

//     &__icon{
//         height: 30px;
//         width: 30px;
//         // border-radius: 50px;
//         // border: solid 2px white;
//         margin-right: 25px;
//         position: relative;
//     }

//     &__text{
//         margin-right: 15px;
//         @include myFont();
//         font-size: 16px;
//         font-weight: 300;
//         width: 80%;
//     }

//     &__arrow{
//       & img{
//         position: relative;
//         top: 2px;
//         height: 25px;
//         right: 2px;
//       }
//     }
// }

@media (max-width: 1699px){
  nav{
    width: 70px;
  }

  .header{
    margin-left: 10px;
    margin-right: 10px;

    &__avatar{
      margin-right: 0;
      width : 46px;
      height: 46px;
      border-width: 2px;
    }

    &__text{
      display: none;
    }

    & > i{
      display: none;
    }
  }

  .links{
    margin-left: 15px;
    margin-right: 15px;
  }

}

</style>
